import { render, staticRenderFns } from "./jitsi-for-meetings-conf.html?vue&type=template&id=539eb462&scoped=true&external"
import script from "./jitsi-for-meetings-conf.js?vue&type=script&lang=js&external"
export * from "./jitsi-for-meetings-conf.js?vue&type=script&lang=js&external"
import style0 from "./jitsi-for-meetings-conf.scss?vue&type=style&index=0&id=539eb462&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539eb462",
  null
  
)

export default component.exports